import React, { FC } from "react";

import CsobForm from "@components/main/csob/hub/Form/CsobForm";

const CsobFormPage: FC = () => <CsobForm />;

export default CsobFormPage;
